import React from 'react'

function Reviews() {
  return (
    <div>
   
<script src="https://static.elfsight.com/platform/platform.js" async></script>
<div class="elfsight-app-9351e312-581f-45b5-a308-f7a91b568151" data-elfsight-app-lazy></div>
    </div>
  )
}

export default Reviews
